<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="370"
      id="confirmDialog"
    >
      <v-card>
        <v-card-title>{{ $vuetify.lang.t('$vuetify.infoModal.info')}}</v-card-title>

        <v-card-text style="font-size: 1rem !important;" v-html="msg" />

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="submitBtn()"
          >
            {{ $vuetify.lang.t('$vuetify.infoModal.confirm')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    data () {
        return {
            dialog: false
        }
    },
    props: {
        msg: {
            type: String,
            default: null
        }
    },
    methods: {
        submitBtn () {
            this.$emit('ok-submit')
            this.dialog = false
        }
    }
}
</script>
